export const SORTER_KEYS = ['order', 'produtos']

export const EXCLUSIVE_URL_BLOCKED_PARAMS = ['bank']

export const DEFAULT_META_TAGS = {
  title: 'Leroy Merlin - Construção, Acabamento, Decoração e Jardinagem',
  description: 'Precisa construir, reformar ou decorar a sua casa? Aqui você encontra mais de 100 mil itens com a garantia de menor preço. Confira nossas ofertas!',
  image: window?.env && `${window.env.assetHost}/assets/frontend/images/leroy-merlin-brasil.svg`
}
